import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  role: string | null;
  displayRole: string | undefined;
  public isOpen: boolean = false;

  constructor(private router: Router, private elementRef: ElementRef) { }

  ngOnInit() {
    this.role = localStorage.getItem('role');

    // Determine displayRole based on the fetched role
    this.displayRole = 'Admin';
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
  }

  // Close the menu when clicking anywhere outside of it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.isOpen = false;
  }

  goToProfile() {
    this.isOpen = false;
    this.router.navigateByUrl('/dashboard/profile');
  }

  logoutUser() {
    this.isOpen = false;
    localStorage.clear();
    this.router.navigateByUrl('auth/login');
  }
}
